import React from "react";
import { TableHead, TableRow } from "@material-ui/core";

import {
  ButtonTableCell,
  StyledTableCell
} from "../../../components/sharedStyledComponents";

export const RoleTableHeader: React.FunctionComponent = () => (
  <TableHead>
    <TableRow>
      <StyledTableCell>Name</StyledTableCell>
      <StyledTableCell>Subscription</StyledTableCell>
      <ButtonTableCell />
    </TableRow>
  </TableHead>
);
